import React from "react";

import { serverErrorImage } from "@ippon/shared-assets";

import PageError from "./PageError";

export interface ServerErrorProps {
  actionLabel?: string;
  onRetry?: () => void;
}

const ServerError: React.FC<ServerErrorProps> = ({
  actionLabel = "ホームへ",
  onRetry,
}) => {
  return (
    <PageError
      actionLabel={actionLabel}
      imageSrc={serverErrorImage}
      message={"現在サービスを利用できません。\n時間をおいて再度お試しください。"}
      onRetry={onRetry}
      statusCode="500"
      title="サーバーエラーが発生しました"
    />
  );
};

export default ServerError;
